import { render, staticRenderFns } from "./PatientTypeStatistics.vue?vue&type=template&id=8d97dbc4&"
import script from "./PatientTypeStatistics.vue?vue&type=script&lang=js&"
export * from "./PatientTypeStatistics.vue?vue&type=script&lang=js&"
import style0 from "./PatientTypeStatistics.vue?vue&type=style&index=0&id=8d97dbc4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d97dbc4')) {
      api.createRecord('8d97dbc4', component.options)
    } else {
      api.reload('8d97dbc4', component.options)
    }
    module.hot.accept("./PatientTypeStatistics.vue?vue&type=template&id=8d97dbc4&", function () {
      api.rerender('8d97dbc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/statistics/patient-type/PatientTypeStatistics.vue"
export default component.exports